import { render, staticRenderFns } from "./OrderCollectBoxesHistoryPopup.vue?vue&type=template&id=0574f20d&scoped=true&"
import script from "./OrderCollectBoxesHistoryPopup.vue?vue&type=script&lang=js&"
export * from "./OrderCollectBoxesHistoryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0574f20d",
  null
  
)

export default component.exports